import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../Translate';

import('./style.scss');

function AssignmentStatus({
  status = 'accept',
  className = '',
  children = '',
}) {
  let item = '';
  switch (status) {
    case 'accept':
      item = Translate({ content: 'status.accept' });
      break;
    case 'cancelled':
      item = Translate({ content: 'status.cancelled' });
      break;
    case 'reported':
      item = Translate({ content: 'status.reported' });
      break;
    case 'inquiry':
      item = Translate({ content: 'status.inquiry' });
      break;
    case 'performed':
      item = Translate({ content: 'status.performed' });
      break;
    case 'onGoing':
      item = Translate({ content: 'status.onGoing' });
      break;
    default:
      break;
  }

  return (
    <div className={className}>
      {children}
      <span className={`tv-assignment-status tv-assignment-status--${status}`}>
        {item}
      </span>
    </div>
  );
}
AssignmentStatus.propTypes = {
  status: PropTypes.string,
  children: PropTypes.string,
  className: PropTypes.string,
};

export default AssignmentStatus;
